import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import type { MitComercialMetadata } from '../../core/models';

/** Metadata comercial en solo lectura, para el detalle del mandato y el de la transacción. */
@Component({
  selector: 'app-mit-comercial-metadata-view',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  template: `
    @if (showTitle()) {
      <h3 class="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
        <i class="pi pi-tags"></i>
        Metadata comercial
      </h3>
    }
    @if (rows().length === 0) {
      <p class="text-sm text-slate-500 m-0">Sin metadata comercial.</p>
    } @else {
      <div class="overflow-hidden overflow-x-auto rounded-lg border border-slate-200">
        <table class="w-full text-sm">
          <thead class="border-b border-slate-200 bg-slate-50">
            <tr>
              <th class="whitespace-nowrap px-4 py-2 text-left text-xs font-semibold uppercase text-slate-700">Llave</th>
              <th class="whitespace-nowrap px-4 py-2 text-left text-xs font-semibold uppercase text-slate-700">Valor</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-200">
            @for (row of rows(); track row.key) {
              <tr>
                <td class="whitespace-nowrap px-4 py-2 font-medium text-slate-900">{{ row.key }}</td>
                <td class="px-4 py-2 text-slate-700 break-all" [class.font-mono]="row.number">{{ row.value }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      @if (hint()) {
        <p class="text-xs text-slate-500 m-0 mt-2">{{ hint() }}</p>
      }
    }
  `
})
export class MitComercialMetadataViewComponent {
  metadata = input<MitComercialMetadata | null | undefined>(null);
  hint = input<string | null>(null);
  showTitle = input(true);

  rows = computed(() =>
    Object.entries(this.metadata() ?? {}).map(([key, value]) => ({ key, value: String(value), number: typeof value === 'number' }))
  );
}
